import { MaterialStatesType } from "./materialContext";
import { Actions } from "./types";

export enum materialStatesPayloadTypes {
  SET_ITEM_ID = "SET_ITEM_ID",
  SUPPLIERS = "SUPPLIERS",
}
export const reducer = (state: MaterialStatesType, action: Actions) => {
  switch (action.type) {
    case materialStatesPayloadTypes.SET_ITEM_ID:
      return {
        ...state,
        itm: action.payload.itm,
      };

    case materialStatesPayloadTypes.SUPPLIERS:
      return {
        ...state,
        selectedSuppliers: action.payload.selectedSuppliers,
      };

    default:
      return state;
  }
};
